import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableColumnDef } from "../../components/DataTable";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type ColumnActions = {
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  lang: ContentLanguage;
};

export const buildContactColumns = ({
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  lang,
}: ColumnActions): TableColumnDef[] => [
  {
    header: "Name",
    render: (row: any) => (lang === "de" ? row?.contactName_ger : row?.contactName) || "-",
    getValue: (row: any) => lang === "de" ? row?.contactName_ger : row?.contactName,
  },
  {
    header: "E-Mail",
    render: (row: any) => row?.email,
    getValue: (row: any) => row?.email,
  },
  {
    header: "Telefonnummer",
    render: (row: any) => row?.telephoneNo,
    getValue: (row: any) => row?.telephoneNo,
  },
  {
    header: "Einzelheiten",
    render: (row: any) => {
      const details = lang === "de" ? row?.contactDetails_ger : row?.contactDetails;
      return (
        <Box className="showmore-class" sx={{ textAlign: "justify", p: 1 }}>
          {details?.length > 80 ? details?.substring(0, 80) + "..." : details}
        </Box>
      );
    },
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canEdit && (
          <Tooltip title="Bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <CreateIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="Löschen" arrow>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
